'use client'
import React, { useState } from 'react'
import HeroSection from '@/components/industry-co-led/HeroSection';
import AboutProgram from '@/components/industry-co-led/AboutProgram';
import OurOffering from "@/components/industry-co-led/OurOffering"
import { BhmData } from '@/data/industry-co-led/redversity/Bhmdata';
import { courseDetails } from '@/data/industry-co-led/redversity/courseDetails';
import WhySection from '@/components/industry-co-led/WhySection';
import MSUAdvantages from '@/components/industry-co-led/MSUAdvantages';
import CTASection from '@/components/industry-co-led/ui/CTASection';
import Eligibility from '@/components/industry-co-led/Eligibility';
import CurriculumStructure from "@/components/industry-co-led/CurriculumStructure";
import StudentStoriesSection from "@/components/industry-co-led/medhavianSpeak";
import FAQSection from "@/components/industry-co-led/FAQSection";
import InfrastructureSection from "@/components/industry-co-led/InfrastructureSection";
import AdditionalSkills from "@/components/industry-co-led/addintionSkill"
import OnTheJobTraining from '@/components/industry-co-led/OnTheJobTraining';
import UserFormModal from '@/components/industry-co-led/UserFormModal';
import { useFormModal } from "@/context/FormContext";
import VideoModal from '@/components/videoModel';
import EligibilitySection from '@/components/industry-co-led/EligibilitySection';
import CareerProspects from '@/components/industry-co-led/CareerProspects';
import CourseStickyBar from '@/components/industry-co-led/CourseSticky';

const Bhm = () => {
    const {
        isOpen,
        shouldDownload,
        closeForm,
        handleSuccess,
        openDownloadForm,
        openApplyForm,
        modal,
        closeVideo,
    } = useFormModal();

    const brochureUrl =
        "https://cdn.msu.edu.in/pdf/MSU_Fee_Structure_2026_27.pdf";

    const brochureName =
        "MSU-FEE-STRUCTURE-2026-27.pdf";

    return (
        <>

            <section className="w-full ">
                <HeroSection data={BhmData}
                    onDownload={() =>
                        openDownloadForm(
                            brochureUrl,
                            brochureName
                        )
                    }
                    onApply={() =>
                        openApplyForm()
                    }
                />
                <AboutProgram data={BhmData} />
                <OurOffering data={BhmData} />
                <WhySection data={BhmData} />
                <MSUAdvantages data={BhmData} />
                <CTASection data={BhmData}
                    onApplyNow={openApplyForm}
                />
                {/* <OnTheJobTraining
                    data={BhmData.onJobtrainningData}
                /> */}
                <AdditionalSkills courseSections={BhmData.addtionSkill.courseSections}
                    onApplyNow={openApplyForm}
                />
                <InfrastructureSection data={BhmData.DoExperienceLearndata} />
                <StudentStoriesSection studentStoriesData={BhmData.studentStoriesData} />
                <EligibilitySection data={BhmData} onApplyNow={openApplyForm}/>
                <CareerProspects data={BhmData.careerProspects}/>

                <CurriculumStructure curriculumData={BhmData.curriculumStructure} />
                <FAQSection course={BhmData.faq} />
            </section>

            <UserFormModal
                isOpen={isOpen}
                onClose={closeForm}
                onSuccess={handleSuccess}
                shouldDownload={shouldDownload}
                courseDetails={courseDetails.redversity.UG}
                specialization={"Healthcare Management"}
                course={"BBA (3 Years)"}
                schoolName={"Management & Commerce"}
                stream={""}
            />

            <VideoModal
                open={modal.open}
                url={modal.url}
                onClose={closeVideo}
            />
            <CourseStickyBar coursePrice={BhmData.coursePrice} onApply={() =>openApplyForm()}  />
        </>
    )
}

export default Bhm